app.service('productLimitedService',function(console, modal, loading, validate) {
	var $self;
	var service, product;

	function sendSuccess(html) {
		console.log('SPRAWDZENIE DOSTĘPNOŚCI USŁUG - OK');
		$self.html(html);
		$self.removeClass('loading');
	}
	function sendError(html) {
		console.log('SPRAWDZENIE DOSTĘPNOŚCI USŁUG - ERROR');
		$self.removeClass('loading');
	}
	function send(form) {
		$self.addClass('loading');
		$(form).ajaxSubmit({
			url: '/check-limited-service-availability.ltr',
			data:{
				serviceId: service
			},
			success:function(data) {
				sendSuccess(data.responseMsg);
			},
			error:function(){
				sendError();
			}
		});
	}
	function loadSuccess(content) {
		loading.stop();
		modal.generate({
			content: content,
			id: 'services-dialog',
			callbackOpen: function() {
				setElements();
				setEvents();
			}
		});
	}
	function loadError(){
		console.log('SPRAWDZANIE LIMITÓW USŁUG - ERROR');
		loading.stop();
	}
	function load(serviceId, productId) {
		console.log('SPRAWDZANIE LIMITÓW USŁUG');
		loading.start();
		service = serviceId;
		product = productId;
		$.ajax({
			url:'/limited-service-availability.ltr',
			success:function(html){
				loadSuccess(html);
			},
			error:function(html){
				loadError();
			}
		});
	}
	function setEvents() {
		validate.task('limitedService', function(form) {
			send(form);
		});
		$.cityAutocomplete('#limited-service-zip-code', '#limited-service-city-name');

	}
	function setElements() {
		$self = $('#limited-service-box');
	}
	function init(serviceId, productId){
		load(serviceId, productId);
	}
	return {
		init:init
	};
});